export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Martes_Banner.1ea964e3.png";